import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { UsersService } from '../../backend/api/users.service';
import { BasePagedComponent } from '../../core/components/base-paged/base-paged.component';
import { DialogService } from '../../core/dialog/dialog.service';
import { AuthService } from '../../core/services/auth.service';
import { ConfirmDialogComponent } from '../../shared/dialogs/confirm-dialog/confirm-dialog.component';
import { SaveUserDialogComponent } from './../../shared/dialogs/save-user-dialog/save-user-dialog.component';
import { UntypedFormControl } from '@angular/forms';

interface UserRow {
  id: number;
  name: string;
  email: string;
}

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss'],
})
export class UsersComponent extends BasePagedComponent implements OnInit {
  data: UserRow[] = [];
  searchQueryControl = new UntypedFormControl('');
  isLoading = false;

  constructor(
    private dialogService: DialogService,
    private usersService: UsersService,
    authService: AuthService,
    t: TranslateService,
    messageService: NzMessageService
  ) {
    super(authService, t, messageService);
  }

  ngOnInit() {
    this.loadData();
  }

  loadData() {
    this.isLoading = true;

    this.usersService
      .apiUsersGet({
        ...this.tableData,
        filter: JSON.stringify({
          search: this.searchQueryControl.value,
        }),
      })
      .subscribe(
        (res) => {
          this.pageLoaded(res);
          this.isLoading = false;
          this.data =
            res.results?.map((x) => ({
              id: x.id || 0,
              name: x.name || '',
              email: x.email || '',
            })) || [];
        },
        (err) => {
          this.isLoading = false;
        }
      );
  }

  searchUsers() {
    this.loadData();
  }

  new() {
    this.dialogService
      .open(SaveUserDialogComponent, {
        size: 'md',
        closeOnClickOutside: false,
      })
      .afterClosed.subscribe((res) => {
        if (res?.saved) {
          this.loadData();
        }
      });
  }

  edit(id: number) {
    this.dialogService
      .open(SaveUserDialogComponent, {
        size: 'md',
        closeOnClickOutside: false,
        data: {
          id,
        },
      })
      .afterClosed.subscribe((res) => {
        if (res?.saved) {
          this.loadData();
        }
      });
  }

  delete(id: number) {
    this.dialogService
      .open(ConfirmDialogComponent, {
        size: 'md',
      })
      .afterClosed.subscribe((res) => {
        if (res?.confirmed) {
          this.usersService.apiUsersIdDelete({ id }).subscribe((res) => {
            this.loadData();
          });
        }
      });
  }
}
